<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-12">
            <h4 class="card-title font-weight-bold">Evaluate revised version</h4>
          </div>
        </div>
        <div class="row">
            <div class="col-sm-7">
              <div class="form-group">
                <label for="revision_status">Approved Status:</label>
                <select class="form-control"
                  v-model="EvaluationForm.model.revision_status"
                  name="revision_status"
                  :disabled="!EvaluationForm.isEditable"
                >
                  <option :value="status" v-for="status in ['APPROVED', 'REJECTED']" :key="status">{{status}}</option>
                </select>
              </div>
            </div>
          </div>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import ApplicationInfo from '../ApplicationInfo';

  export default {
    components: {
      InfoRight,
      ApplicationInfo
    },
    data() {
      return {
        EvaluationForm
      }
    },
    beforeCreate() {
      if (!EvaluationForm.files.budget) {
        EvaluationForm.files.budget = {};
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      }
    }
  }
</script>
